import { render } from "./BaseProfile.vue?vue&type=template&id=df532e00&scoped=true"
import script from "./BaseProfile.vue?vue&type=script&lang=js"
export * from "./BaseProfile.vue?vue&type=script&lang=js"

import "./BaseProfile.vue?vue&type=style&index=0&id=df532e00&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df532e00"]])

export default __exports__